export type WindowScreen = 'ticket' | 'call';

export type CallSession = 'idle' | 'dialing' | 'live' | 'review';

export interface IWindowScreenState {
  screen: WindowScreen;
  session: CallSession;
}

export type WindowScreenEvent =
  | { type: 'dialStarted' }
  | { type: 'connected' }
  | { type: 'ended'; hasCallId: boolean }
  | { type: 'reviewDismissed' }
  | { type: 'back' }
  | { type: 'showCall' }
  | { type: 'dialFailed' };

export const initialWindowScreenState: IWindowScreenState = {
  screen: 'ticket',
  session: 'idle',
};

export const windowScreenReducer = (
  state: IWindowScreenState,
  event: WindowScreenEvent,
): IWindowScreenState => {
  switch (event.type) {
    case 'dialStarted':
      return { screen: 'call', session: 'dialing' };
    case 'connected':
      return { ...state, session: 'live' };
    case 'ended':
      return event.hasCallId
        ? { screen: 'call', session: 'review' }
        : { screen: 'call', session: 'idle' };
    case 'reviewDismissed':
      return { screen: 'ticket', session: 'idle' };
    case 'back':
      return { ...state, screen: 'ticket' };
    case 'showCall':
      return { ...state, screen: 'call' };
    case 'dialFailed':
      return { screen: 'call', session: 'idle' };
    default:
      return state;
  }
};

export const isCallInProgress = (state: IWindowScreenState): boolean =>
  state.session === 'dialing' || state.session === 'live';

export const needsCloseConfirm = (state: IWindowScreenState): boolean =>
  isCallInProgress(state);

export const showsLiveCallBar = (state: IWindowScreenState): boolean =>
  state.screen === 'ticket' && isCallInProgress(state);
